export const translations = {
    de: {
        nav: {
            about: "Über Mich",
            audiences: "Für Wen",
            methods: "Methodik",
            therapy: "Dorn-Breuss",
            programs: "Programme",
            benefits: "Vorteile",
            testimonials: "Erfolge",
            booking: "Kennenlerngespräch",
            analysis: "Persönliche Analyse",
            shop: "Shop",
            blog: "Journal",
            apply: "Bewerben",
            home: "Start",
            learn_more: "Mehr erfahren",
            agb: "AGB",
        },
        hero: {
            overline: "Premium Transformation · Schweiz",
            title_a: "Dein Ziel.",
            title_b: "Dein Weg.",
            title_c: "Dein Erfolg.",
            script: "Ich begleite dich dorthin.",
            description:
                "Ganzheitliches Premium-Coaching für Frauen, Männer und Familien — Mindset, Körper, Ernährung und Business. Strukturiert. Diskret. Nachhaltig.",
            cta_apply: "Persönliche Analyse",
            cta_whatsapp: "WhatsApp Kontakt",
            cta_book: "Kennenlerngespräch",
            badge_1: "Über 250 Transformationen",
            badge_2: "1:1 Begleitung",
            badge_3: "Schweizer Qualität",
            highlight: "Du stehst im Mittelpunkt. Dein Erfolg ist mein Ziel.",
        },
        audiences: {
            overline: "Für Wen ist ELLA Online Coaching?",
            title: "Ganzheitlich. Individuell. Nachhaltig.",
            subtitle:
                "Ein Coaching für Menschen, die bereit sind, ihr Leben neu zu gestalten — unabhängig von Alter, Geschlecht oder Ausgangspunkt.",
            closer: "Ein Coaching. Alle Bereiche. Dein Leben. Deine Regeln. Dein Erfolg.",
            items: [
                {
                    id: "mothers",
                    label: "Mütter",
                    headline: "Für dich, die jeden Tag alles gibt.",
                    description:
                        "Du gibst jeden Tag dein Bestes für alle — jetzt ist es Zeit, etwas für dich zu tun.",
                    points: [
                        "Mehr Energie im Alltag",
                        "Wohlfühlkörper & Selbstvertrauen",
                        "Struktur in chaotischen Phasen",
                        "Zurück zu dir selbst",
                    ],
                },
                {
                    id: "men",
                    label: "Männer",
                    headline: "Stärker. Klarer. Fokussierter.",
                    description:
                        "Du willst stärker, gesünder und fokussierter werden — im Körper, im Kopf und in deinem Leben.",
                    points: [
                        "Muskelaufbau & Fettabbau",
                        "Leistungsfähigkeit & Energie",
                        "Mentale Stärke",
                        "Klarheit & Selbstdisziplin",
                    ],
                },
                {
                    id: "families",
                    label: "Familien",
                    headline: "Gemeinsam wachsen.",
                    description:
                        "Gemeinsam verändern. Gemeinsam wachsen. Für ein gesundes und harmonisches Leben.",
                    points: [
                        "Gesunde Routinen",
                        "Starke emotionale Bindung",
                        "Mehr Lebensqualität",
                        "Gemeinsame Ziele & Werte",
                    ],
                },
                {
                    id: "strugglers",
                    label: "Belastende Phasen",
                    headline: "Du musst da nicht alleine durch.",
                    description:
                        "Ob Krise, Verlust oder Neuanfang — ich begleite dich mit Erfahrung, Empathie und Klarheit.",
                    points: [
                        "Emotionale Unterstützung",
                        "Klarheit & Orientierung",
                        "Stärke von innen",
                        "Neuer Lebensmut",
                    ],
                },
                {
                    id: "seekers",
                    label: "Ohne klare Richtung",
                    headline: "Finde deinen Purpose.",
                    description:
                        "Du suchst deinen Sinn und willst dein Leben in die richtige Richtung lenken.",
                    points: [
                        "Ziele finden & definieren",
                        "Purpose entdecken",
                        "Strategie & Umsetzung",
                        "Ein Leben mit Sinn",
                    ],
                },
            ],
        },
        about: {
            overline: "Über Mercedes Köstel",
            title: "Eine Geschichte, die verbindet. Eine Mission, die trägt.",
            intro_quote: "Ich bin nicht gekommen, um dir zu sagen, was du hören willst. Sondern um mit dir zu gehen, bis dein Leben sich verändert hat.",
            chapters: [
                {
                    heading: "Persönliche Geschichte",
                    overline: "Mein Weg",
                    body: "Ich bin Mercedes Köstel — Mutter von drei Kindern, Transformation Coach und Gründerin von ELLA Online Coaching. Mein Weg war nicht geradlinig, und gerade deshalb verstehe ich, was es bedeutet, alles zu geben — und sich dabei selbst zu verlieren. Ich weiss, wie es ist, in einer belastenden Beziehung zu kämpfen, Erfahrungen mit häuslicher Gewalt zu durchleben und dennoch jeden Morgen aufzustehen, um für die Menschen da zu sein, die dich brauchen. Meine eigene Transformation beruht auf einer einzigen Entscheidung: nicht mehr weiterzuleben wie bisher — sondern bewusst, stark und mit Würde. Heute begleite ich Frauen, Männer und Familien auf genau diesem Weg.",
                },
                {
                    heading: "Erfahrung",
                    overline: "Mein Fundament",
                    body: "Meine Reise hat mir über die Jahre ein einzigartiges Fundament gegeben. Als ausgebildete Make-up Artistin und Stylistin habe ich verstanden, wie sehr unser Äusseres mit unserem Inneren verbunden ist — und wie Frauen und Männer sich selbst wahrnehmen. In der Verkaufswelt habe ich gelernt, wirklich zuzuhören, echte Bedürfnisse zu erkennen und Menschen zu Lösungen zu führen. Als Personal Trainerin arbeite ich seit Jahren mit Körpern in Veränderung — für Gewichtsverlust, Kraft, Form und nachhaltige Energie. Parallel dazu habe ich mich intensiv in die Psychologie vertieft — denn ohne mentale Arbeit bleibt jede körperliche Veränderung oberflächlich.",
                },
                {
                    heading: "Mission",
                    overline: "Warum ich das tue",
                    body: "Ich glaube nicht an Einheitslösungen. Jeder Mensch ist anders, jede Geschichte einzigartig. Deshalb begleite ich dich ganzheitlich — mit Trainings- und Ernährungsstrategie, hormonellem Verständnis, Mindsetarbeit, echtem familiären Rückhalt und unternehmerischer Klarheit. Mein Fokus liegt besonders auf Müttern und Frauen, die ihre Kraft zurückgewinnen wollen — aber mein Coaching steht bewusst auch Männern und Familien offen. Denn Transformation kennt kein Geschlecht.",
                },
                {
                    heading: "Coaching Philosophie",
                    overline: "Wie ich arbeite",
                    body: "Mein Coaching beruht auf drei Säulen: Authentizität, Struktur und Verbindlichkeit. Ich halte dir keinen Spiegel vor — ich gehe mit dir durch den Raum, bis du selbst wieder weisst, wer du bist. Jede Strategie wird individuell entwickelt. Jede Woche begleitet. Jeder Fortschritt wird ernst genommen. Du bist keine Nummer. Du bist ein Mensch mit einer Geschichte — und mit einer Zukunft, die wir gemeinsam gestalten.",
                },
            ],
            stats: [
                { value: "3", label: "Kinder" },
                { value: "10+", label: "Jahre Erfahrung" },
                { value: "250+", label: "Transformationen" },
                { value: "1:1", label: "Persönlich" },
            ],
            sign: "Mercedes Köstel",
            sign_role: "Transformation Coach · Schweiz",
        },
        about_summary: {
            overline: "Über Mercedes",
            title: "Eine Geschichte, die verbindet.",
            lead: "Mutter von drei Kindern. Transformation Coach. Gründerin von ELLA. Mein Weg war nicht geradlinig — und genau deshalb verstehe ich, was es bedeutet, alles zu geben und sich dabei selbst zu verlieren.",
            highlight_label: "Was mich antreibt",
            highlight_body: "Authentizität, Struktur und Verbindlichkeit. Ich halte dir keinen Spiegel vor — ich gehe mit dir, bis du selbst wieder weisst, wer du bist.",
            cta: "Meine ganze Geschichte lesen",
        },
        previews: {
            methods: {
                overline: "Methodik",
                title: "Sechs Säulen. Eine Transformation.",
                lead: "Business, Mindset, Ernährung, Hormone, 24/7 Support, persönliche Planung — ganzheitlich verzahnt.",
                cta: "Methodik im Detail",
            },
            therapy: {
                overline: "Dorn-Breuss-Therapie",
                title: "Sanfte Wirbelsäulen-Therapie · 185 CHF.",
                lead: "Dorn richtet, Breuss entspannt — eine ganzheitliche Sitzung für Körper, Atem und Wirbelsäule.",
                cta: "Mehr erfahren · Sitzung buchen",
            },
            programs: {
                overline: "Programme",
                title: "4, 8 oder 12 Wochen Begleitung.",
                lead: "Drei Premium-Pakete, server-seitig validierte Preise und sichere Stripe-Zahlung in CHF.",
                items_label: ["4 Wochen", "8 Wochen", "12 Wochen"],
                cta: "Alle Pakete vergleichen",
            },
            booking: {
                overline: "Kennenlerngespräch",
                title: "20 Minuten · kostenfrei · unverbindlich.",
                lead: "Wir lernen uns kennen, du erzählst von deinem Ziel — ich zeige dir, wie ich dich begleiten würde.",
                cta: "Termin reservieren",
            },
            analysis: {
                overline: "Persönliche Analyse",
                title: "Dein Premium 5-Schritte-Intake.",
                lead: "Ein vertraulicher Fragebogen, der mir alles zeigt, was ich für deine Begleitung wissen muss.",
                cta: "Analyse starten",
            },
            benefits: {
                overline: "Erfolge",
                title: "Echte Veränderung. Echte Stimmen.",
                lead: "Was Klientinnen und Klienten nach drei Monaten sagen — Worte, die uns geblieben sind.",
            },
        },
        page_meta: {
            back_home: "Zurück zur Startseite",
            on_this_page: "Auf dieser Seite",
            seo: {
                home: {
                    title: "ELLA Online Coaching · Premium Transformation Schweiz",
                    h1: "Premium Online Coaching aus der Schweiz – Mercedes Köstel",
                    description:
                        "Ganzheitliches Premium-Coaching für Frauen, Männer und Familien · Mindset, Ernährung, Hormone, Business · Diskret, individuell, nachhaltig.",
                },
                about: {
                    title: "Über Mercedes Köstel · Transformation Coach Schweiz",
                    h1: "Über Mercedes Köstel – Premium Transformation Coach Schweiz",
                    description:
                        "Mercedes Köstel · Mutter, Coach, Gründerin von ELLA. Premium-Begleitung für nachhaltige Transformation in der Schweiz.",
                },
                methodik: {
                    title: "Methodik · 6 Säulen Premium Coaching Schweiz",
                    h1: "Coaching-Methodik – Sechs Säulen für nachhaltige Transformation",
                    description:
                        "Business, Mindset, Ernährung, Hormone, 24/7 Support und persönliche Planung — die sechs Säulen meines Premium-Coachings.",
                },
                therapy: {
                    title: "Dorn-Breuss-Therapie · Sanfte Wirbelsäulen-Behandlung",
                    h1: "Dorn-Breuss-Therapie – Sanfte Wirbelsäulen-Behandlung in der Schweiz",
                    description:
                        "Ganzheitliche Dorn-Breuss-Sitzung für Körper, Atem und Wirbelsäule. 185 CHF pro Behandlung in der Schweiz.",
                },
                programs: {
                    title: "Coaching-Programme · 4, 8 & 12 Wochen Premium Begleitung",
                    h1: "Premium Coaching-Programme – 4, 8 und 12 Wochen Begleitung",
                    description:
                        "Drei Premium-Coaching-Pakete (399, 800, 1400 CHF) — sichere Zahlung via Stripe. Individuelle Begleitung mit Mercedes Köstel.",
                },
                booking: {
                    title: "Kennenlerngespräch · Kostenloses 20-Minuten-Erstgespräch",
                    h1: "Kennenlerngespräch – Dein kostenloses 20-Minuten-Erstgespräch",
                    description:
                        "Reserviere dein kostenloses Erstgespräch online. 20 Minuten, online, unverbindlich — mit Mercedes Köstel.",
                },
                analysis: {
                    title: "Persönliche Analyse · Premium Coaching-Anfrage",
                    h1: "Persönliche Analyse – Premium Coaching-Anfrage Schweiz",
                    description:
                        "Vertraulicher 5-Schritte-Fragebogen für dein Premium-Coaching. Mercedes antwortet persönlich innerhalb von 48 Stunden.",
                },
                blog: {
                    title: "Journal · Reflexionen über Transformation & Mindset",
                    h1: "Journal – Reflexionen über Transformation, Mindset und Familie",
                    description:
                        "Gedanken und Praxis aus meinem Coaching — Mindset, Ernährung, Familie. Lange Texte, die in die Tiefe gehen.",
                },
                impressum: {
                    title: "Impressum · ELLA Online Coaching",
                    description: "Impressum gemäss schweizerischem Recht.",
                },
                datenschutz: {
                    title: "Datenschutz · ELLA Online Coaching",
                    description: "Datenschutzerklärung gemäss DSG und DSGVO.",
                },
                agb: {
                    title: "AGB · Términos y Condiciones · ELLA Online Coaching",
                    description: "Allgemeine Geschäftsbedingungen und Términos y Condiciones.",
                },
            },
        },
        blog: {
            overline: "Journal",
            title: "Gedanken, die tragen.",
            subtitle: "Reflexionen über Transformation, Mindset, Körper und Familie — direkt aus meiner Praxis.",
            cta_all: "Alle Artikel lesen",
            cta_read: "Weiterlesen",
            list_title: "Journal · Reflexionen & Praxis",
            list_subtitle: "Lange Texte, die in die Tiefe gehen. Kurz und ehrlich, wenn nötig. Immer aus der Erfahrung.",
            back_to_blog: "Zurück zum Journal",
            min_read: "Min. Lesezeit",
            published_on: "Veröffentlicht am",
            posts: [
                {
                    slug: "in-deiner-staerke-bleiben",
                    title: "In deiner Stärke bleiben — auch wenn das Leben dich kennt",
                    excerpt: "Kraft entsteht nicht im Sieg, sondern in den Momenten, in denen niemand zusieht. Ein Gedanke über Würde, Konsistenz und das, was bleibt.",
                    date: "12. Januar 2026",
                    read_minutes: 6,
                    category: "Mindset",
                    image: "https://images.unsplash.com/photo-1499744937866-d7e566a20a61?auto=format&fit=crop&w=1600&q=80",
                    body: [
                        "Es gibt Tage, an denen alles leichter scheint. Du fühlst dich klar, du fühlst dich stark, und es ist einfach, in deiner Mitte zu bleiben. Aber das ist nicht der Test.",
                        "Der Test kommt an einem Dienstagabend, wenn du übermüdet bist, die Kinder geschrien haben, der Kühlschrank halb leer ist und du dich fragst, ob das wirklich dein Leben ist.",
                        "In meiner eigenen Geschichte habe ich gelernt: Stärke ist nicht das Gefühl, das uns hochträgt. Stärke ist die Entscheidung, weiterzumachen, wenn das Gefühl längst weg ist. Es ist die Disziplin der Würde — auch wenn niemand zusieht.",
                        "Wenn du heute in einer schweren Phase bist: Es geht nicht darum, dich besser zu fühlen. Es geht darum, dich konsequent so zu behandeln, wie es die Person verdient, die du sein willst. Das ist die Brücke. Das ist der Weg.",
                        "Ich begleite Menschen seit Jahren durch genau diese Stellen. Es geht nie um den grossen Sprung — es geht um die kleinen, leisen Entscheidungen, die niemand applaudiert. Aber gerade die formen das Leben, das du am Ende leben wirst.",
                    ],
                },
                {
                    slug: "ernaehrung-ohne-dogma",
                    title: "Ernährung ohne Dogma — was wirklich funktioniert",
                    excerpt: "Keine Wunderdiäten. Keine Dogmen. Nur eine ehrliche Frage: Was passt zu deinem Leben — und nicht zu jemand anderem?",
                    date: "28. Dezember 2025",
                    read_minutes: 5,
                    category: "Ernährung",
                    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=1600&q=80",
                    body: [
                        "Die wichtigste Regel der Ernährung steht in keinem Buch: Sie muss zu deinem Leben passen. Nicht zu meinem. Nicht zu deiner Freundin. Nicht zu Instagram.",
                        "Ich habe in meiner Praxis Hunderte Menschen begleitet — Mütter mit drei Kindern, Männer mit anstrengenden Schichten, Familien mit ganz verschiedenen Vorlieben. Niemand davon braucht eine Diät. Sie brauchen eine Strategie, die in einen echten Tag hineinpasst.",
                        "Drei Prinzipien, die ich konsequent anwende: Erstens, genug Protein, damit dein Körper sich regenerieren kann. Zweitens, echte Lebensmittel — so unverarbeitet wie möglich, ohne Perfektionsdruck. Drittens, ein Rhythmus, der zu deinem Alltag passt, nicht umgekehrt.",
                        "Was ich nicht mache: Lebensmittel verbieten, die zur Kultur deiner Familie gehören. Pläne erstellen, die nur Single-Männer am Wochenende durchhalten. Versprechen, die nur funktionieren, wenn dein Leben perfekt ist.",
                        "Wenn du dich in einer Diät befindest, die du heimlich hasst — beende sie. Beginne stattdessen mit einer Strategie, die du in zehn Jahren immer noch leben könntest. Genau das ist Nachhaltigkeit.",
                    ],
                },
                {
                    slug: "familie-als-team",
                    title: "Familie als Team — gemeinsam wachsen, statt nebeneinander leben",
                    excerpt: "Die meisten Familien wohnen miteinander. Wenige funktionieren wirklich als Team. Ein Plädoyer für gemeinsame Routinen, Werte und Wachstum.",
                    date: "10. Dezember 2025",
                    read_minutes: 7,
                    category: "Familie",
                    image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1600&q=80",
                    body: [
                        "Eine Familie ist nicht automatisch ein Team. Sie wird es. Oder sie wird es nicht.",
                        "In meiner Arbeit mit Familien sehe ich immer wieder dieselbe Konstellation: Jeder funktioniert für sich, jeder hat seinen Stress, jeder gibt sein Bestes — aber niemand zieht in dieselbe Richtung. Das Resultat ist Erschöpfung. Nicht aus Mangel an Liebe, sondern aus Mangel an Struktur.",
                        "Was Familien wirklich verändert, sind nicht grosse Gesten. Es sind drei kleine Dinge: Eine gemeinsame Mahlzeit am Tag, an der alle ohne Telefon dabei sind. Ein Wochengespräch, in dem jedes Familienmitglied sagen darf, was schwer war und was gut. Ein gemeinsames Ziel, das die ganze Familie trägt — und nicht nur die Eltern.",
                        "Eltern denken oft, sie müssten alles tragen. Aber Kinder sind keine Last. Sie sind Mitspielende. Wenn du sie als Team behandelst, werden sie zum Team. Sie wachsen, wenn sie Verantwortung dürfen. Sie verbinden sich, wenn sie gefragt werden.",
                        "Mein Coaching ist deshalb bewusst auch für Familien offen. Denn deine eigene Transformation ist immer mit den Menschen verbunden, mit denen du lebst. Wenn du wächst, wachsen sie mit. Aber nur, wenn ihr es gemeinsam tut.",
                    ],
                },
            ],
        },
        methods: {
            overline: "Methodik · Ein Coaching, alle Bereiche",
            title: "Sechs Säulen. Eine Transformation.",
            subtitle:
                "Ganzheitliche Begleitung für Körper, Geist, Alltag und Lebenswirklichkeit.",
            items: [
                {
                    title: "Business-Coaching",
                    desc: "Strategien, Klarheit und Umsetzung für deinen beruflichen Erfolg und nachhaltiges Wachstum.",
                },
                {
                    title: "Mindset-Coaching",
                    desc: "Negative Gedanken loslassen, Selbstvertrauen stärken und die beste Version deiner selbst werden.",
                },
                {
                    title: "Ernährungsberatung",
                    desc: "Individuelle Ernährung, die zu deinem Alltag passt und dich nachhaltig zu deinen Zielen bringt.",
                },
                {
                    title: "Hormonbalance",
                    desc: "Ganzheitliche Unterstützung für mehr innere Balance, Energie und Wohlbefinden.",
                },
                {
                    title: "24/7 WhatsApp-Support",
                    desc: "Ich bin für dich da — jederzeit, wenn du Unterstützung, Motivation oder Antworten brauchst.",
                },
                {
                    title: "Persönliche Planung",
                    desc: "Massgeschneiderte Pläne mit Herz, Verständnis und voller Hingabe — bis zu deiner Zielerreichung.",
                },
            ],
        },
        partners: {
            overline: "Ausbildung & Qualifikationen",
            title: "Schweizer Qualität. Geprüfte Ausbildung.",
            subtitle:
                "Mercedes Köstel hat ihre Ausbildung an anerkannten Schweizer Bildungsinstituten absolviert.",
            items: [
                {
                    name: "SAFS",
                    fullName: "Swiss Academy of Fitness & Sports",
                    badge: "Bildungsinstitut",
                    logo: "https://customer-assets.emergentagent.com/job_ella-transform/artifacts/jv0i7cr6_93dbf703-34fa-4395-83ca-613a2f2bc36c.jpg",
                    url: "https://www.safs.com",
                    description:
                        "Mercedes Köstel hat ihre Fitness- und Gesundheitsausbildung bei der SAFS absolviert. Die SAFS ist führender Schweizer Bildungsanbieter seit 1986 — von Grundkursen bis zu eidgenössischen Diplomen.",
                },
                {
                    name: "kibesuisse",
                    fullName: "Verband Kinderbetreuung Schweiz",
                    badge: "Bildungsinstitut",
                    logo: "https://customer-assets.emergentagent.com/job_ella-transform/artifacts/kwhpqpm2_54eef42e-3bb0-4612-b985-a48b3198c375.JPG",
                    url: "https://www.kibesuisse.ch",
                    description:
                        "Ausbildung in familienergänzender Betreuung: kibesuisse ist der Schweizer Branchenverband für Kinderbetreuung und stellt das Kindeswohl ins Zentrum.",
                },
                {
                    name: "BASPO",
                    fullName: "Bundesamt für Sport · Anerkannte Ausbildung",
                    badge: "Eidgenössisch",
                    logo: "/baspo-badge.svg",
                    url: "https://www.baspo.admin.ch",
                    description:
                        "Anerkannt durch das Schweizerische Bundesamt für Sport (BASPO) — eidgenössisch geprüfte Qualifikation für Sport, Bewegung und Gesundheitsförderung.",
                },
            ],
        },
        therapy: {
            overline: "Körperarbeit · Premium Therapie",
            title: "Dorn-Breuss-Therapie.",
            subtitle:
                "Eine sanfte Verbindung zweier ganzheitlicher Methoden — für Wirbelsäule, Haltung und tiefe Regeneration.",
            intro:
                "Die Dorn-Breuss-Therapie verbindet zwei traditionsreiche Ansätze zu einer ruhigen, kraftvollen Behandlung. Sie hilft, Spannungen zu lösen, Schmerzen zu lindern und Körper und Geist in eine tiefe Balance zurückzuführen.",
            method_label: "Methode",
            methods: [
                {
                    name: "Dorn-Methode",
                    desc: "Eine sanfte manuelle Methode zur achtsamen Korrektur von Wirbeln und Gelenken. Wirksam bei Rücken-, Hüft- und Gelenkbeschwerden — ohne ruckartige Bewegungen.",
                },
                {
                    name: "Breuss-Massage",
                    desc: "Eine ruhige, meditative Rückenmassage mit Johanniskrautöl. Sie dehnt die Wirbelsäule sanft, entspannt die Bandscheiben und lädt den Körper energetisch wieder auf.",
                },
            ],
            benefits_label: "Wirkung",
            benefits: [
                "Linderung von Rücken-, Haltungs- und Ischiasbeschwerden",
                "Lösung von muskulären Verspannungen",
                "Tiefe körperliche und mentale Entspannung",
                "Gesteigertes Wohlbefinden und neue Energie",
                "Verbesserung der Körperhaltung",
            ],
            details_label: "Investition",
            duration_label: "Dauer",
            price: "185 CHF",
            duration: "45 – 60 Minuten",
            per_session: "pro Sitzung",
            cta: "Jetzt Termin Buchen",
            cta_alt: "Per WhatsApp anfragen",
            disclaimer:
                "Hinweis: Die Dorn-Breuss-Therapie ist eine ergänzende Wohlfühlbehandlung und ersetzt keine ärztliche Diagnose oder Behandlung.",
        },
        programs: {
            overline: "Coaching Programme",
            title: "Wähle deinen Weg.",
            subtitle:
                "Drei Premium-Programme — abgestimmt auf dein Tempo, deine Ziele und dein Leben. Für Frauen, Männer und Familien.",
            most_popular: "Am Beliebtesten",
            cta: "Programm Wählen",
            cta_buy: "Jetzt Kaufen",
            cta_apply_first: "Erst bewerben",
            currency: "CHF",
            packages: [
                {
                    id: "4_weeks",
                    name: "4 Wochen Coaching",
                    duration: "Starter",
                    price: 399,
                    tagline: "Der erste Schritt in ein neues Ich.",
                    features: [
                        "Individueller Trainingsplan",
                        "Persönlicher Ernährungsplan",
                        "1× Anpassung nach 2 Wochen",
                        "Persönliches Onboarding-Gespräch",
                    ],
                },
                {
                    id: "8_weeks",
                    name: "8 Wochen Coaching",
                    duration: "Premium",
                    price: 800,
                    tagline: "Echte Veränderung. Sichtbare Resultate.",
                    features: [
                        "Trainingsplan + laufende Updates",
                        "Ernährungsplan + regelmässige Anpassungen",
                        "Persönliche 1:1 Betreuung",
                        "Wöchentlicher Check-in",
                        "Direkter Chat-Support",
                    ],
                    highlighted: true,
                },
                {
                    id: "12_weeks",
                    name: "12 Wochen Intensiv",
                    duration: "Transformation",
                    price: 1400,
                    tagline: "Maximale Transformation. Komplett individuell.",
                    features: [
                        "Komplett individuelle Betreuung",
                        "Trainings- & Ernährungsstrategie",
                        "24/7 WhatsApp-Support",
                        "Mentale Begleitung & Mindset",
                        "Familien- & Business-Klarheit",
                        "Hormonelle Balance-Beratung",
                    ],
                },
            ],
            payment_note:
                "Sichere Zahlung via Stripe, PayPal oder Anzahlung — Details nach deiner persönlichen Analyse.",
        },
        benefits: {
            overline: "Für alle, die...",
            title: "Was du erreichst.",
            subtitle:
                "Sechs nachhaltige Veränderungen, die dein Leben neu ausrichten.",
            items: [
                { title: "Körperliche Veränderung", desc: "Gewichtsverlust, Muskelaufbau und ein Körper, in dem du dich zuhause fühlst." },
                { title: "Mehr Energie", desc: "Gesünder und nachhaltig leben. Aufwachen mit Leichtigkeit, den Tag mit Kraft gestalten." },
                { title: "Mentale Stärke", desc: "Mental stärker und ausgeglichener werden. Klarheit in jedem Lebensbereich." },
                { title: "Klare Struktur", desc: "Eine klare Strategie und Struktur — auch in den anspruchsvollsten Phasen." },
                { title: "Selbstvertrauen", desc: "Dich wieder spüren, dich wieder wahrnehmen, dich wieder ganz leben." },
                { title: "Nachhaltige Resultate", desc: "Das Beste aus sich herausholen. Veränderung, die bleibt." },
            ],
        },
        testimonials: {
            overline: "Echte Erfolge",
            title: "Stimmen, die für sich sprechen.",
            items: [
                { name: "Sarah M.", role: "Mutter, 38", text: "Mercedes hat mir nicht nur 14 Kilo abgenommen — sondern mir mein Selbstvertrauen zurückgegeben. Heute fühle ich mich wieder wie ich." },
                { name: "Daniel K.", role: "Unternehmer, 44", text: "Ich kam für Muskelaufbau — und ging mit einem komplett neuen Mindset. Klarheit in Körper, Kopf und Geschäft." },
                { name: "Familie B.", role: "Familie, 2 Kinder", text: "Endlich Struktur in unserem Alltag. Unser ganzes Familienleben hat sich verändert — gemeinsam, Schritt für Schritt." },
                { name: "Julia R.", role: "Krankenschwester, 29", text: "Persönlich. Diskret. Wirksam. Genau das, was ich gebraucht habe — und genau das, was ich bekommen habe." },
            ],
        },
        booking: {
            overline: "Kennenlerngespräch",
            title: "Lass uns reden.",
            subtitle:
                "Buche dein kostenloses 20-minütiges Erstgespräch. Wir schauen ehrlich, ob wir zusammenpassen.",
            placeholder_note:
                "Online-Buchung wird in Kürze freigeschaltet. Bis dahin freue ich mich über deine Nachricht — persönlich und direkt.",
            duration: "20 Minuten",
            duration_label: "Dauer",
            type: "Video-Call · 1:1",
            type_label: "Format",
            cost: "Kostenlos",
            cost_label: "Investition",
            availability: "Mo – Fr · 09:00 – 18:00 (CET)",
            availability_label: "Verfügbarkeit",
            preview_title: "Erstgespräch · Online",
            preview_lead: "In nur 20 Minuten finden wir gemeinsam heraus, ob wir zusammenpassen.",
            cta_whatsapp: "Termin via WhatsApp",
            cta_email: "Termin per E-Mail",
            cta_apply: "Direkt bewerben",
            soon_badge: "In Kürze online buchbar",
            fallback_label: "Lieber persönlich?",
            fallback_lead:
                "Wenn du keinen passenden Slot findest oder lieber direkt schreiben möchtest — Mercedes antwortet persönlich.",
            times_overline: "Verfügbare Zeiten",
            modal: {
                title: "Termin anfragen",
                subtitle: "Mercedes bestätigt deinen Wunsch-Termin innerhalb von 24 Stunden per E-Mail oder WhatsApp.",
                slot_label: "Dein gewählter Termin",
                name: "Name",
                email: "E-Mail",
                phone: "Telefon",
                submit: "Terminanfrage senden",
                submitting: "Wird gesendet…",
                cancel: "Abbrechen",
                success: "Danke! Deine Anfrage ist bei Mercedes angekommen. Sie meldet sich innerhalb von 24h.",
                error: "Etwas ist schiefgelaufen. Bitte versuche es erneut oder schreibe uns direkt via WhatsApp.",
                privacy: "Deine Daten werden vertraulich behandelt.",
            },
        },
        analysis: {
            overline: "Persönliche Analyse",
            title: "Deine Premium Intake.",
            subtitle:
                "Ein strukturiertes Analyse-Gespräch beginnt mit ehrlichen Fragen. Nimm dir 5–7 Minuten. Deine Antworten werden streng vertraulich behandelt.",
            steps: ["Persönliches", "Ziele", "Körper", "Alltag", "Bereitschaft"],
            step_labels: {
                step: "Schritt",
                of: "von",
                next: "Weiter",
                back: "Zurück",
                submit: "Analyse Abschicken",
                submitting: "Wird gesendet...",
                success: "Danke — deine Analyse ist bei Mercedes angekommen. Du hörst persönlich innerhalb von 24 Stunden.",
                error: "Etwas ist schief gelaufen. Bitte versuche es nochmal.",
                privacy: "Alle Angaben werden vertraulich behandelt (Datenschutz).",
            },
            fields: {
                name: "Vor- und Nachname",
                email: "E-Mail Adresse",
                phone: "Telefon / WhatsApp",
                age: "Alter",
                canton: "Wohnort / Kanton",
                focus: "Dein Hauptfokus",
                focus_options: {
                    weight: "Gewicht & Körper",
                    mindset: "Mindset & Mentale Stärke",
                    nutrition: "Ernährung",
                    hormones: "Hormonbalance",
                    business: "Business & Klarheit",
                    family: "Familie & Beziehung",
                    allround: "Ganzheitliche Transformation",
                },
                goal: "Was ist dein grösstes Ziel der nächsten 3 Monate?",
                goal_since: "Wie lange verfolgst du dieses Ziel schon?",
                tried: "Was hast du bisher versucht, um es zu erreichen?",
                life_change: "Wie würde sich dein Leben verändern, wenn du es erreichst?",
                nutrition_desc: "Wie würdest du deine aktuelle Ernährung beschreiben?",
                allergies: "Unverträglichkeiten oder Allergien?",
                meals: "Mahlzeiten pro Tag",
                sleep_hours: "Stunden Schlaf pro Nacht",
                sleep_quality: "Schlafqualität (1–10)",
                health_issues: "Aktuelle gesundheitliche Einschränkungen?",
                medication: "Medikamente?",
                typical_day: "Wie sieht ein typischer Tag bei dir aus?",
                activity_hours: "Aktive Stunden pro Woche",
                time_available: "Wie viele Stunden kannst du wöchentlich investieren?",
                family_situation: "Beschreibe kurz deine Familiensituation.",
                support: "Fühlst du dich von deinem Umfeld unterstützt?",
                blockers: "Was hält dich aktuell davon ab, dein Ziel zu erreichen?",
                readiness: "Veränderungsbereitschaft (1–10)",
                expectations: "Was erwartest du von einem Coaching?",
                why_now: "Warum gerade jetzt?",
                investment: "Bist du bereit, in dich selbst zu investieren? Budget-Rahmen",
                investment_options: {
                    "under_400": "Unter 400 CHF",
                    "400_800": "400 – 800 CHF",
                    "800_1400": "800 – 1400 CHF",
                    "1400_plus": "1400+ CHF",
                    unsure: "Noch unentschieden",
                },
                other: "Gibt es etwas, das ich über dich wissen sollte?",
            },
            scale_weak: "Gar nicht",
            scale_strong: "Voll",
        },
        shop: {
            overline: "ELLA Shop",
            title: "In Kürze — deine Premium Tools.",
            subtitle:
                "Ein wachsender Raum für digitale Produkte, Ernährungspläne, E-Books und exklusive Coaching-Pakete.",
            soon_badge: "Coming Soon",
            items: [
                { title: "Digitale E-Books", desc: "Mindset, Ernährung und Transformation — strukturiert zum Selbststudium." },
                { title: "Ernährungspläne", desc: "Vorgefertigte Pläne für Alltag, Familie und gezielte Ziele." },
                { title: "Gruppenprogramme", desc: "Exklusive Premium-Gruppen mit persönlicher Betreuung." },
                { title: "Physische Produkte", desc: "Kuratierte Auswahl an hochwertigen Tools & Essentials." },
            ],
            notify: "Benachrichtige mich beim Launch",
        },
        footer: {
            tagline: "Körper. Seele. Familie. Business. Wachstum.",
            navigation: "Navigation",
            contact: "Kontakt",
            legal: "Rechtliches",
            impressum: "Impressum",
            datenschutz: "Datenschutz",
            agb: "AGB",
            rights: "Alle Rechte vorbehalten.",
            address_placeholder: "Adresse wird ergänzt · Schweiz",
            cta_line: "Bereit für Veränderung? Ich freue mich darauf, dich kennenzulernen.",
            quote: "Du bist stärker, als du denkst. Ich helfe dir, es zu erkennen.",
        },
        legal: {
            back: "Zurück zur Startseite",
            impressum_title: "Impressum",
            datenschutz_title: "Datenschutz",
            placeholder:
                "Dieser Text ist ein Platzhalter und wird mit den finalen rechtlichen Inhalten ergänzt.",
            impressum: {
                title: "Impressum",
                intro:
                    "Angaben gemäss schweizerischem Bundesgesetz gegen den unlauteren Wettbewerb (UWG) sowie den Bestimmungen der EU-DSGVO.",
                provider_heading: "Anbieterin",
                legal_form: "Einzelunternehmen / Coaching-Praxis",
                address_pending: "Schweiz",
                address_note:
                    "Die vollständige Geschäftsadresse wird mit der finalen Domain-Aufschaltung veröffentlicht.",
                website: "www.ella-onlinecoaching.ch",
                responsible_heading: "Verantwortlich für den Inhalt",
                responsible_body:
                    "Mercedes Köstel ist als Inhaberin verantwortlich für sämtliche Inhalte dieser Website. Anfragen, Korrektur- und Auskunftswünsche werden ausschliesslich über die oben angegebenen Kontaktdaten bearbeitet.",
                disclaimer_heading: "Haftungsausschluss",
                disclaimer_content:
                    "Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität wird jedoch keine Gewähr übernommen. Coaching-Inhalte sind keine medizinische, psychologische oder therapeutische Beratung und ersetzen keine fachärztliche Behandlung.",
                disclaimer_links:
                    "Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung erfolgen auf eigene Gefahr.",
                copyright_heading: "Urheberrecht",
                copyright_body:
                    "Alle auf dieser Website veröffentlichten Texte, Bilder, Grafiken sowie das Layout sind urheberrechtlich geschützt. Eine Vervielfältigung, Bearbeitung, Verbreitung oder Verwertung ausserhalb der Grenzen des Urheberrechts bedarf der schriftlichen Zustimmung der Anbieterin.",
                jurisdiction:
                    "Anwendbares Recht: Schweiz · Gerichtsstand: Wohnsitz der Anbieterin",
            },
            datenschutz: {
                title: "Datenschutzerklärung",
                intro:
                    "Der Schutz deiner persönlichen Daten ist mir ein wichtiges Anliegen. Diese Datenschutzerklärung informiert dich gemäss schweizerischem Datenschutzgesetz (DSG) sowie der EU-Datenschutz-Grundverordnung (DSGVO) über die Art, den Umfang und den Zweck der Datenerhebung auf dieser Website.",
                controller_label: "Verantwortliche Stelle",
                last_updated: "Stand: Februar 2026",
                rights_label: "Deine Rechte",
                rights_title: "Du behältst die Kontrolle über deine Daten.",
                rights_body:
                    "Gemäss DSG und DSGVO stehen dir jederzeit folgende Rechte zu. Eine kurze E-Mail genügt — ich antworte persönlich innerhalb von 7 Tagen.",
                rights_items: [
                    "Recht auf Auskunft über gespeicherte Daten",
                    "Recht auf Berichtigung unzutreffender Daten",
                    "Recht auf Löschung („Recht auf Vergessenwerden“)",
                    "Recht auf Einschränkung der Verarbeitung",
                    "Recht auf Datenübertragbarkeit",
                    "Recht auf Widerruf einer erteilten Einwilligung",
                ],
                rights_cta: "Datenschutz-Anfrage senden",
                sections: [
                    {
                        heading: "Welche Daten werden erfasst",
                        body: [
                            "Beim Ausfüllen des Analyse- oder Kontaktformulars erhebe ich ausschliesslich die Daten, die du mir freiwillig übermittelst: Name, E-Mail, Telefonnummer (optional), Alter sowie deine inhaltlichen Antworten zu Zielen, Lebenssituation, Ernährung, Schlaf und Gesundheit. Diese Angaben werden vertraulich behandelt.",
                            "Beim Aufruf der Website werden serverseitig automatisch nicht-personenbezogene Logdaten gespeichert (anonymisierte IP, Browsertyp, Referrer, Zeitstempel). Diese dienen ausschliesslich der technischen Sicherheit und werden nicht zur Profilbildung verwendet.",
                        ],
                    },
                    {
                        heading: "Zweck und Rechtsgrundlage",
                        body: [
                            "Die Verarbeitung deiner Daten erfolgt zur Vorbereitung und Durchführung der von dir angefragten Coaching-Leistungen, zur Beantwortung deiner Anfrage sowie zur Erfüllung vertraglicher Pflichten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. Art. 31 Abs. 2 lit. a DSG.",
                            "Eine Übermittlung deiner Daten an Dritte erfolgt nur, soweit dies für die Erbringung der Dienstleistung zwingend erforderlich ist (siehe nächste Sektion).",
                        ],
                    },
                    {
                        heading: "Cookies und Tracking",
                        body: [
                            "Diese Website verwendet keine Marketing- oder Tracking-Cookies. Es werden ausschliesslich technisch notwendige Cookies eingesetzt (z. B. zur Sprachwahl DE/ES). Du musst diesen nicht zustimmen, da keine Auswertung deines Verhaltens stattfindet.",
                        ],
                    },
                    {
                        heading: "Auftragsverarbeiter & eingebundene Dienste",
                        body: [
                            "Für die einwandfreie Funktion der Website nutze ich folgende sorgfältig ausgewählte Dienstleister, mit denen entsprechende Auftragsverarbeitungs-Verträge bestehen:",
                        ],
                        list: [
                            "Stripe Payments Europe Ltd. (IRL) — Zahlungsabwicklung der Coaching-Pakete",
                            "Resend, Inc. (USA) — Versand von Bestätigungs-E-Mails",
                            "LoopBook (Max Web Design, CH) — Online-Terminbuchung für das Kennenlerngespräch",
                            "MongoDB Atlas (EU-Region) — sichere Speicherung der Formular-Eingaben",
                        ],
                    },
                    {
                        heading: "Speicherdauer & Sicherheit",
                        body: [
                            "Deine Daten werden ausschliesslich so lange gespeichert, wie es für den Zweck der Verarbeitung erforderlich ist oder gesetzliche Aufbewahrungspflichten dies vorschreiben (max. 10 Jahre für Geschäftsunterlagen gemäss OR Art. 958f).",
                            "Die Übertragung erfolgt durchgängig verschlüsselt via HTTPS/TLS. Der Zugang zu personenbezogenen Daten ist auf die Anbieterin beschränkt.",
                        ],
                    },
                ],
            },
        },
    },
    es: {
        nav: {
            about: "Sobre Mí",
            audiences: "Para Quién",
            methods: "Método",
            therapy: "Dorn-Breuss",
            programs: "Programas",
            benefits: "Beneficios",
            testimonials: "Éxitos",
            booking: "Primera Sesión",
            analysis: "Análisis Personal",
            shop: "Tienda",
            blog: "Diario",
            apply: "Postular",
            home: "Inicio",
            learn_more: "Más información",
            agb: "Términos y Condiciones",
        },
        hero: {
            overline: "Transformación Premium · Suiza",
            title_a: "Tu Meta.",
            title_b: "Tu Camino.",
            title_c: "Tu Éxito.",
            script: "Te acompaño hasta allí.",
            description:
                "Coaching premium integral para mujeres, hombres y familias — mindset, cuerpo, nutrición y negocio. Estructurado. Discreto. Sostenible.",
            cta_apply: "Análisis Personal",
            cta_whatsapp: "Contacto WhatsApp",
            cta_book: "Primera Sesión",
            badge_1: "Más de 250 transformaciones",
            badge_2: "Acompañamiento 1:1",
            badge_3: "Calidad Suiza",
            highlight: "Tú eres el centro. Tu éxito es mi meta.",
        },
        audiences: {
            overline: "¿Para quién es ELLA Online Coaching?",
            title: "Integral. Individual. Sostenible.",
            subtitle:
                "Un coaching para personas listas para rediseñar su vida — sin importar edad, género o punto de partida.",
            closer: "Un coaching. Todas las áreas. Tu vida. Tus reglas. Tu éxito.",
            items: [
                { id: "mothers", label: "Madres", headline: "Para ti, que lo das todo cada día.", description: "Das lo mejor de ti todos los días — ahora es momento de hacer algo por ti.", points: ["Más energía diaria", "Cuerpo y confianza", "Estructura en el caos", "Volver a ti"] },
                { id: "men", label: "Hombres", headline: "Más fuerte. Más claro. Más enfocado.", description: "Quieres ser más fuerte, saludable y enfocado — en cuerpo, mente y vida.", points: ["Músculo y pérdida de grasa", "Rendimiento y energía", "Fortaleza mental", "Claridad y disciplina"] },
                { id: "families", label: "Familias", headline: "Crecer juntos.", description: "Cambiar juntos. Crecer juntos. Por una vida sana y armoniosa.", points: ["Rutinas saludables", "Vínculo emocional fuerte", "Más calidad de vida", "Objetivos comunes"] },
                { id: "strugglers", label: "Momentos difíciles", headline: "No tienes que pasarlo sola.", description: "Crisis, pérdida o nuevo comienzo — te acompaño con experiencia, empatía y claridad.", points: ["Apoyo emocional", "Claridad y orientación", "Fuerza interior", "Nuevo valor para vivir"] },
                { id: "seekers", label: "Sin rumbo claro", headline: "Encuentra tu propósito.", description: "Buscas tu sentido y quieres dirigir tu vida en la dirección correcta.", points: ["Definir objetivos", "Descubrir propósito", "Estrategia y acción", "Una vida con sentido"] },
            ],
        },
        about: {
            overline: "Sobre Mercedes Köstel",
            title: "Una historia que conecta. Una misión que sostiene.",
            intro_quote: "No vine a decirte lo que quieres oír. Vine a caminar contigo hasta que tu vida haya cambiado.",
            chapters: [
                { heading: "Historia personal", overline: "Mi camino", body: "Soy Mercedes Köstel — madre de tres hijos, Transformation Coach y fundadora de ELLA Online Coaching. Mi camino no fue lineal, y por eso mismo comprendo lo que significa darlo todo y perderse en el proceso. Sé lo que es luchar en una relación difícil, vivir experiencias de violencia doméstica y aun así levantarse cada mañana por las personas que te necesitan. Mi transformación nació de una sola decisión: no seguir viviendo como hasta entonces — sino de forma consciente, fuerte y con dignidad. Hoy acompaño a mujeres, hombres y familias por ese mismo camino." },
                { heading: "Experiencia", overline: "Mi base", body: "A lo largo de los años he construido una base única. Como maquilladora profesional y estilista, aprendí cuán conectados están nuestro exterior e interior. En el mundo de las ventas aprendí a escuchar de verdad, reconocer necesidades reales y guiar a las personas hacia soluciones. Como Personal Trainer, trabajo desde hace años con cuerpos en cambio — pérdida de peso, fuerza, forma y energía sostenible. En paralelo, me formé profundamente en psicología — porque sin trabajo mental, todo cambio físico se queda en la superficie." },
                { heading: "Misión", overline: "Por qué lo hago", body: "No creo en las soluciones universales. Cada persona es distinta. Por eso te acompaño de forma integral — con estrategia de entrenamiento y nutrición, entendimiento hormonal, trabajo de mindset, apoyo familiar real y claridad empresarial. Mi foco está en madres y mujeres que quieren recuperar su fuerza — pero mi coaching está conscientemente abierto también a hombres y familias. Porque la transformación no tiene género." },
                { heading: "Filosofía", overline: "Cómo trabajo", body: "Mi coaching se basa en tres pilares: autenticidad, estructura y compromiso. No te pongo un espejo — camino contigo por la habitación hasta que vuelvas a saber quién eres. Cada estrategia se diseña individualmente. Cada semana se acompaña. Cada avance se toma en serio. No eres un número. Eres una persona con una historia — y con un futuro que construimos juntas." },
            ],
            stats: [
                { value: "3", label: "Hijos" },
                { value: "10+", label: "Años de experiencia" },
                { value: "250+", label: "Transformaciones" },
                { value: "1:1", label: "Personalizado" },
            ],
            sign: "Mercedes Köstel",
            sign_role: "Transformation Coach · Suiza",
        },
        about_summary: {
            overline: "Sobre Mercedes",
            title: "Una historia que conecta.",
            lead: "Madre de tres. Transformation Coach. Fundadora de ELLA. Mi camino no fue lineal — y por eso entiendo lo que significa darlo todo y perderse en el proceso.",
            highlight_label: "Lo que me mueve",
            highlight_body: "Autenticidad, estructura y compromiso. No te pongo un espejo — camino contigo hasta que vuelvas a saber quién eres.",
            cta: "Leer mi historia completa",
        },
        previews: {
            methods: {
                overline: "Método",
                title: "Seis pilares. Una transformación.",
                lead: "Business, mindset, nutrición, hormonas, soporte 24/7 y planificación personal — todo entrelazado.",
                cta: "Ver método en detalle",
            },
            therapy: {
                overline: "Terapia Dorn-Breuss",
                title: "Terapia vertebral suave · 185 CHF.",
                lead: "Dorn alinea, Breuss relaja — una sesión integral para cuerpo, respiración y columna.",
                cta: "Ver más · Reservar sesión",
            },
            programs: {
                overline: "Programas",
                title: "4, 8 o 12 semanas de acompañamiento.",
                lead: "Tres paquetes Premium, precios validados en servidor y pago seguro Stripe en CHF.",
                items_label: ["4 Semanas", "8 Semanas", "12 Semanas"],
                cta: "Comparar todos los paquetes",
            },
            booking: {
                overline: "Primera Sesión",
                title: "20 minutos · gratuita · sin compromiso.",
                lead: "Nos conocemos, me cuentas tu objetivo — te muestro cómo te acompañaría.",
                cta: "Reservar cita",
            },
            analysis: {
                overline: "Análisis Personal",
                title: "Tu intake Premium en 5 pasos.",
                lead: "Un cuestionario confidencial que me muestra todo lo que necesito para acompañarte.",
                cta: "Empezar análisis",
            },
            benefits: {
                overline: "Éxitos",
                title: "Cambio real. Voces reales.",
                lead: "Lo que las clientes y clientes dicen después de tres meses — palabras que se nos quedaron.",
            },
        },
        page_meta: {
            back_home: "Volver al inicio",
            on_this_page: "En esta página",
            seo: {
                home: {
                    title: "ELLA Online Coaching · Transformación Premium Suiza",
                    h1: "Coaching Online Premium desde Suiza – Mercedes Köstel",
                    description:
                        "Coaching Premium integral para mujeres, hombres y familias · Mindset, nutrición, hormonas, negocio · Discreto, individual, sostenible.",
                },
                about: {
                    title: "Sobre Mercedes Köstel · Transformation Coach Suiza",
                    h1: "Sobre Mercedes Köstel – Coach Premium de Transformación en Suiza",
                    description:
                        "Mercedes Köstel · Madre, coach, fundadora de ELLA. Acompañamiento Premium para una transformación sostenible en Suiza.",
                },
                methodik: {
                    title: "Método · 6 Pilares de Coaching Premium en Suiza",
                    h1: "Método de Coaching – Seis pilares para una transformación sostenible",
                    description:
                        "Business, mindset, nutrición, hormonas, soporte 24/7 y planificación personal — los seis pilares de mi coaching Premium.",
                },
                therapy: {
                    title: "Terapia Dorn-Breuss · Tratamiento vertebral suave",
                    h1: "Terapia Dorn-Breuss – Tratamiento vertebral suave en Suiza",
                    description:
                        "Sesión Dorn-Breuss integral para cuerpo, respiración y columna. 185 CHF por sesión en Suiza.",
                },
                programs: {
                    title: "Programas de Coaching · 4, 8 y 12 semanas Premium",
                    h1: "Programas de Coaching Premium – 4, 8 y 12 semanas",
                    description:
                        "Tres paquetes Premium de coaching (399, 800, 1400 CHF) — pago seguro vía Stripe. Acompañamiento individual con Mercedes Köstel.",
                },
                booking: {
                    title: "Primera Sesión · 20 min gratuita y sin compromiso",
                    h1: "Primera Sesión – Tu cita gratuita de 20 minutos",
                    description:
                        "Reserva tu primera sesión gratuita online. 20 minutos, online, sin compromiso — con Mercedes Köstel.",
                },
                analysis: {
                    title: "Análisis Personal · Solicitud de Coaching Premium",
                    h1: "Análisis Personal – Solicitud de Coaching Premium en Suiza",
                    description:
                        "Cuestionario confidencial de 5 pasos para tu coaching Premium. Mercedes responde personalmente en 48 horas.",
                },
                blog: {
                    title: "Diario · Reflexiones sobre transformación y mindset",
                    h1: "Diario – Reflexiones sobre transformación, mindset y familia",
                    description:
                        "Pensamientos y práctica desde mi coaching — mindset, nutrición, familia. Textos largos que van en profundidad.",
                },
                impressum: {
                    title: "Aviso Legal · ELLA Online Coaching",
                    description: "Aviso legal conforme al derecho suizo.",
                },
                datenschutz: {
                    title: "Privacidad · ELLA Online Coaching",
                    description: "Política de privacidad conforme a LPD y RGPD.",
                },
                agb: {
                    title: "Términos y Condiciones · AGB · ELLA Online Coaching",
                    description: "Términos y Condiciones · Allgemeine Geschäftsbedingungen.",
                },
            },
        },
        blog: {
            overline: "Diario",
            title: "Pensamientos que sostienen.",
            subtitle: "Reflexiones sobre transformación, mindset, cuerpo y familia — directamente desde mi práctica.",
            cta_all: "Ver todos los artículos",
            cta_read: "Seguir leyendo",
            list_title: "Diario · Reflexiones y práctica",
            list_subtitle: "Textos largos que profundizan. Cortos y honestos cuando hace falta. Siempre desde la experiencia.",
            back_to_blog: "Volver al diario",
            min_read: "min de lectura",
            published_on: "Publicado el",
            posts: [
                {
                    slug: "in-deiner-staerke-bleiben",
                    title: "Permanecer en tu fuerza — incluso cuando la vida te conoce",
                    excerpt: "La fuerza no nace en la victoria, sino en los momentos en que nadie observa. Una reflexión sobre dignidad, consistencia y lo que permanece.",
                    date: "12 de enero, 2026",
                    read_minutes: 6,
                    category: "Mindset",
                    image: "https://images.unsplash.com/photo-1499744937866-d7e566a20a61?auto=format&fit=crop&w=1600&q=80",
                    body: [
                        "Hay días en los que todo parece más fácil. Te sientes clara, te sientes fuerte, y permanecer en tu centro es sencillo. Pero ese no es el examen.",
                        "El examen llega un martes por la noche, cuando estás agotada, los niños han gritado, la nevera está medio vacía y te preguntas si esta es realmente tu vida.",
                        "En mi propia historia aprendí: la fuerza no es ese sentimiento que nos eleva. La fuerza es la decisión de continuar, cuando el sentimiento ya se ha ido. Es la disciplina de la dignidad — incluso cuando nadie observa.",
                        "Si hoy estás en una fase difícil: no se trata de sentirte mejor. Se trata de tratarte de forma consecuente, como merece la persona que quieres llegar a ser. Ese es el puente. Ese es el camino.",
                        "Acompaño a personas desde hace años exactamente por estos puntos. Nunca se trata del gran salto — se trata de las pequeñas decisiones silenciosas que nadie aplaude. Pero precisamente esas modelan la vida que vivirás al final.",
                    ],
                },
                {
                    slug: "ernaehrung-ohne-dogma",
                    title: "Nutrición sin dogma — qué funciona realmente",
                    excerpt: "Sin dietas milagrosas. Sin dogmas. Solo una pregunta honesta: ¿qué se ajusta a tu vida — y no a la de otra persona?",
                    date: "28 de diciembre, 2025",
                    read_minutes: 5,
                    category: "Nutrición",
                    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=1600&q=80",
                    body: [
                        "La regla más importante de la nutrición no está en ningún libro: tiene que ajustarse a tu vida. No a la mía. No a la de tu amiga. No a Instagram.",
                        "En mi práctica he acompañado a cientos de personas — madres con tres hijos, hombres con turnos exigentes, familias con preferencias muy distintas. Ninguna de ellas necesitaba una dieta. Necesitaban una estrategia que cupiera en un día real.",
                        "Tres principios que aplico con consistencia: primero, suficiente proteína para que tu cuerpo pueda regenerarse. Segundo, alimentos reales — lo menos procesados posible, sin presión perfeccionista. Tercero, un ritmo que se ajuste a tu rutina, no al revés.",
                        "Lo que no hago: prohibir alimentos que pertenecen a la cultura de tu familia. Crear planes que solo hombres solteros aguantan los fines de semana. Promesas que solo funcionan si tu vida es perfecta.",
                        "Si estás en una dieta que en secreto odias — termínala. Empieza con una estrategia que aún podrías vivir dentro de diez años. Eso es sostenibilidad.",
                    ],
                },
                {
                    slug: "familie-als-team",
                    title: "La familia como equipo — crecer juntos en lugar de vivir uno al lado del otro",
                    excerpt: "La mayoría de las familias conviven. Pocas funcionan realmente como equipo. Un alegato por las rutinas, valores y crecimiento compartidos.",
                    date: "10 de diciembre, 2025",
                    read_minutes: 7,
                    category: "Familia",
                    image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1600&q=80",
                    body: [
                        "Una familia no es automáticamente un equipo. Lo llega a ser. O no lo llega a ser.",
                        "En mi trabajo con familias veo siempre la misma constelación: cada uno funciona por su lado, cada uno carga su propio estrés, cada uno hace lo que puede — pero nadie tira en la misma dirección. El resultado es agotamiento. No por falta de amor, sino por falta de estructura.",
                        "Lo que realmente cambia a las familias no son los grandes gestos. Son tres pequeñas cosas: una comida diaria en la que todos están sin móvil. Una conversación semanal en la que cada miembro puede decir qué fue difícil y qué fue bueno. Un objetivo común que sostiene a toda la familia — no solo a los padres.",
                        "Los padres a menudo creen que tienen que cargar con todo. Pero los hijos no son una carga. Son co-jugadores. Si los tratas como equipo, se convierten en equipo. Crecen cuando pueden tener responsabilidad. Se conectan cuando se les pregunta.",
                        "Por eso mi coaching está conscientemente abierto también a familias. Porque tu propia transformación está siempre conectada con las personas con las que vives. Si tú creces, ellos crecen contigo. Pero solo si lo hacéis juntos.",
                    ],
                },
            ],
        },
        methods: {
            overline: "Método · Un coaching, todas las áreas",
            title: "Seis pilares. Una transformación.",
            subtitle: "Acompañamiento integral para cuerpo, mente, día a día y realidad vital.",
            items: [
                { title: "Business-Coaching", desc: "Estrategia, claridad y ejecución para tu éxito profesional y crecimiento sostenible." },
                { title: "Mindset-Coaching", desc: "Soltar pensamientos negativos, fortalecer la confianza y convertirte en tu mejor versión." },
                { title: "Asesoría nutricional", desc: "Nutrición personalizada que encaja en tu día a día y te lleva de forma sostenible a tus metas." },
                { title: "Balance hormonal", desc: "Acompañamiento integral para más equilibrio interior, energía y bienestar." },
                { title: "Soporte WhatsApp 24/7", desc: "Estoy contigo — cuando necesites apoyo, motivación o respuestas." },
                { title: "Plan personalizado", desc: "Planes a medida con corazón, comprensión y dedicación — hasta alcanzar tu meta." },
            ],
        },
        partners: {
            overline: "Certificaciones y Partners",
            title: "Calidad Suiza. Competencia certificada.",
            subtitle:
                "ELLA Online Coaching colabora con reconocidos partners suizos del sector formativo y profesional.",
            items: [
                {
                    name: "SAFS",
                    fullName: "Swiss Academy of Fitness & Sports",
                    logo: "https://customer-assets.emergentagent.com/job_ella-transform/artifacts/jv0i7cr6_93dbf703-34fa-4395-83ca-613a2f2bc36c.jpg",
                    url: "https://www.safs.com",
                    description:
                        "Principal proveedor formativo suizo en fitness y salud desde 1986. Imparte cursos básicos, diplomas federales y programas Bachelor duales.",
                },
                {
                    name: "kibesuisse",
                    fullName: "Asociación Suiza de Cuidado Infantil",
                    logo: "https://customer-assets.emergentagent.com/job_ella-transform/artifacts/kwhpqpm2_54eef42e-3bb0-4612-b985-a48b3198c375.JPG",
                    url: "https://www.kibesuisse.ch",
                    description:
                        "Asociación suiza para la educación y el cuidado complementario a la familia — pone el bienestar del niño en el centro.",
                },
                {
                    name: "BASPO",
                    fullName: "Oficina Federal del Deporte · Reconocimiento Suizo",
                    logo: "/baspo-badge.svg",
                    url: "https://www.baspo.admin.ch",
                    description:
                        "Reconocida por la Oficina Federal del Deporte de Suiza (BASPO) — cualificación oficial suiza en deporte, movimiento y promoción de la salud.",
                },
            ],
        },
        therapy: {
            overline: "Trabajo corporal · Terapia Premium",
            title: "Terapia Dorn-Breuss.",
            subtitle:
                "Una unión suave de dos métodos integrales — para columna, postura y profunda regeneración.",
            intro:
                "La Terapia Dorn-Breuss combina dos enfoques tradicionales en un tratamiento sereno y poderoso. Ayuda a liberar tensiones, aliviar dolores y devolver al cuerpo y la mente a un equilibrio profundo.",
            method_label: "Método",
            methods: [
                {
                    name: "Método Dorn",
                    desc: "Un método manual suave para corregir vértebras y articulaciones con cuidado. Eficaz frente a dolencias de espalda, cadera y articulaciones — sin movimientos bruscos.",
                },
                {
                    name: "Masaje Breuss",
                    desc: "Un masaje meditativo de espalda con aceite de hipérico. Estira la columna con suavidad, relaja los discos y recarga al cuerpo energéticamente.",
                },
            ],
            benefits_label: "Efectos",
            benefits: [
                "Alivio de dolores de espalda, postura y ciática",
                "Liberación de tensiones musculares",
                "Profunda relajación física y mental",
                "Mayor bienestar y nueva energía",
                "Mejora de la postura corporal",
            ],
            details_label: "Inversión",
            duration_label: "Duración",
            price: "185 CHF",
            duration: "45 – 60 minutos",
            per_session: "por sesión",
            cta: "Reservar Cita",
            cta_alt: "Consultar por WhatsApp",
            disclaimer:
                "Aviso: La Terapia Dorn-Breuss es un tratamiento complementario de bienestar y no sustituye un diagnóstico ni tratamiento médico.",
        },
        programs: {
            overline: "Programas de Coaching",
            title: "Elige tu camino.",
            subtitle: "Tres programas premium — adaptados a tu ritmo, tus metas y tu vida. Para mujeres, hombres y familias.",
            most_popular: "Más Popular",
            cta: "Elegir Programa",
            cta_buy: "Comprar Ahora",
            cta_apply_first: "Postular primero",
            currency: "CHF",
            packages: [
                { id: "4_weeks", name: "4 Semanas Coaching", duration: "Inicio", price: 399, tagline: "El primer paso hacia una nueva versión.", features: ["Plan de entrenamiento individual", "Plan de nutrición personalizado", "1 ajuste tras 2 semanas", "Sesión de onboarding personal"] },
                { id: "8_weeks", name: "8 Semanas Coaching", duration: "Premium", price: 800, tagline: "Cambio real. Resultados visibles.", features: ["Plan de entrenamiento + actualizaciones", "Plan de nutrición + ajustes", "Acompañamiento 1:1", "Check-in semanal", "Soporte directo por chat"], highlighted: true },
                { id: "12_weeks", name: "12 Semanas Intensivo", duration: "Transformación", price: 1400, tagline: "Máxima transformación. Totalmente personalizado.", features: ["Acompañamiento totalmente individual", "Estrategia de entrenamiento y nutrición", "Soporte WhatsApp 24/7", "Acompañamiento mental y mindset", "Claridad familiar y empresarial", "Asesoría de balance hormonal"] },
            ],
            payment_note: "Pago seguro vía Stripe, PayPal o depósito — detalles tras tu análisis personal.",
        },
        benefits: {
            overline: "Para todas las personas que...",
            title: "Lo que vas a lograr.",
            subtitle: "Seis cambios sostenibles que rediseñan tu vida.",
            items: [
                { title: "Cambio físico", desc: "Pérdida de peso, musculatura y un cuerpo en el que te sientes en casa." },
                { title: "Más energía", desc: "Vivir más sano y sostenible. Despertar con ligereza, vivir con fuerza." },
                { title: "Fortaleza mental", desc: "Mentalmente más fuerte y en equilibrio. Claridad en cada ámbito." },
                { title: "Estructura clara", desc: "Estrategia y estructura — incluso en las fases más exigentes." },
                { title: "Confianza", desc: "Volver a sentirte, volver a percibirte, volver a vivirte por completo." },
                { title: "Resultados duraderos", desc: "Sacar lo mejor de ti. Cambios que permanecen." },
            ],
        },
        testimonials: {
            overline: "Éxitos reales",
            title: "Voces que hablan por sí solas.",
            items: [
                { name: "Sarah M.", role: "Madre, 38", text: "Mercedes no solo me ayudó a bajar 14 kilos — me devolvió mi confianza. Hoy vuelvo a sentirme yo." },
                { name: "Daniel K.", role: "Empresario, 44", text: "Vine por musculatura — y me llevé un mindset totalmente nuevo. Claridad en cuerpo, mente y negocio." },
                { name: "Familia B.", role: "Familia, 2 hijos", text: "Por fin estructura en nuestro día. Toda nuestra vida familiar cambió — juntos, paso a paso." },
                { name: "Julia R.", role: "Enfermera, 29", text: "Personal. Discreto. Efectivo. Justo lo que necesitaba — y justo lo que recibí." },
            ],
        },
        booking: {
            overline: "Primera Sesión",
            title: "Conversemos.",
            subtitle: "Reserva tu primera sesión gratuita de 20 minutos. Veremos honestamente si encajamos.",
            placeholder_note: "La reserva online estará disponible muy pronto. Mientras tanto, escríbeme — personal y directo.",
            duration: "20 minutos",
            duration_label: "Duración",
            type: "Video-llamada · 1:1",
            type_label: "Formato",
            cost: "Gratis",
            cost_label: "Inversión",
            availability: "Lun – Vie · 09:00 – 18:00 (CET)",
            availability_label: "Disponibilidad",
            preview_title: "Primera sesión · Online",
            preview_lead: "En solo 20 minutos descubriremos si encajamos.",
            cta_whatsapp: "Cita por WhatsApp",
            cta_email: "Cita por correo",
            cta_apply: "Postular directamente",
            soon_badge: "Reserva online muy pronto",
            fallback_label: "¿Prefieres contacto directo?",
            fallback_lead:
                "Si no encuentras un horario adecuado o prefieres escribirme directamente — Mercedes responde personalmente.",
            times_overline: "Horarios disponibles",
            modal: {
                title: "Solicitar cita",
                subtitle: "Mercedes confirmará tu horario deseado en menos de 24 horas por email o WhatsApp.",
                slot_label: "Tu horario elegido",
                name: "Nombre",
                email: "Correo electrónico",
                phone: "Teléfono",
                submit: "Enviar solicitud",
                submitting: "Enviando…",
                cancel: "Cancelar",
                success: "¡Gracias! Tu solicitud ha llegado a Mercedes. Te contactará en menos de 24h.",
                error: "Algo salió mal. Por favor inténtalo de nuevo o escríbenos directamente por WhatsApp.",
                privacy: "Tus datos son tratados con confidencialidad.",
            },
        },
        analysis: {
            overline: "Análisis Personal",
            title: "Tu Intake Premium.",
            subtitle: "Un análisis estructurado empieza con preguntas honestas. Tómate 5-7 minutos. Tus respuestas son estrictamente confidenciales.",
            steps: ["Personal", "Objetivos", "Cuerpo", "Día a día", "Compromiso"],
            step_labels: { step: "Paso", of: "de", next: "Siguiente", back: "Atrás", submit: "Enviar Análisis", submitting: "Enviando...", success: "¡Gracias! Tu análisis ha llegado a Mercedes. Ella te contactará personalmente en 24 horas.", error: "Algo salió mal. Por favor intenta de nuevo.", privacy: "Todos los datos son tratados con confidencialidad (Privacidad)." },
            fields: {
                name: "Nombre y apellido", email: "Correo electrónico", phone: "Teléfono / WhatsApp", age: "Edad", canton: "Lugar / Cantón",
                focus: "Tu foco principal",
                focus_options: { weight: "Peso y cuerpo", mindset: "Mindset y fuerza mental", nutrition: "Nutrición", hormones: "Balance hormonal", business: "Negocio y claridad", family: "Familia y relación", allround: "Transformación integral" },
                goal: "¿Cuál es tu mayor meta para los próximos 3 meses?", goal_since: "¿Desde cuándo persigues esta meta?", tried: "¿Qué has intentado hasta ahora?", life_change: "¿Cómo cambiaría tu vida al lograrlo?",
                nutrition_desc: "¿Cómo describirías tu nutrición actual?", allergies: "¿Intolerancias o alergias?", meals: "Comidas por día",
                sleep_hours: "Horas de sueño por noche", sleep_quality: "Calidad del sueño (1-10)", health_issues: "¿Limitaciones de salud actuales?", medication: "¿Medicamentos?",
                typical_day: "¿Cómo es un día típico?", activity_hours: "Horas activas por semana", time_available: "¿Cuántas horas puedes invertir por semana?",
                family_situation: "Describe brevemente tu situación familiar.", support: "¿Sientes apoyo de tu entorno?",
                blockers: "¿Qué te frena actualmente?", readiness: "Disposición al cambio (1-10)", expectations: "¿Qué esperas de un coaching?", why_now: "¿Por qué ahora?",
                investment: "¿Estás lista para invertir en ti? Rango de presupuesto",
                investment_options: { "under_400": "Menos de 400 CHF", "400_800": "400 - 800 CHF", "800_1400": "800 - 1400 CHF", "1400_plus": "1400+ CHF", unsure: "Aún indecisa" },
                other: "¿Algo que debería saber sobre ti?",
            },
            scale_weak: "Nada", scale_strong: "Total",
        },
        shop: {
            overline: "ELLA Shop",
            title: "Próximamente — tus herramientas premium.",
            subtitle: "Un espacio en crecimiento para productos digitales, planes de nutrición, e-books y paquetes exclusivos.",
            soon_badge: "Coming Soon",
            items: [
                { title: "E-Books digitales", desc: "Mindset, nutrición y transformación — estructurados para autoestudio." },
                { title: "Planes de nutrición", desc: "Planes listos para tu día a día, familia y objetivos específicos." },
                { title: "Programas grupales", desc: "Grupos premium exclusivos con acompañamiento personal." },
                { title: "Productos físicos", desc: "Selección curada de herramientas y esenciales de alta calidad." },
            ],
            notify: "Avísame del lanzamiento",
        },
        footer: {
            tagline: "Cuerpo. Alma. Familia. Negocio. Crecimiento.",
            navigation: "Navegación", contact: "Contacto", legal: "Legal",
            impressum: "Aviso Legal", datenschutz: "Privacidad", agb: "Términos",
            rights: "Todos los derechos reservados.", address_placeholder: "Dirección por confirmar · Suiza",
            cta_line: "¿Lista para el cambio? Estoy emocionada por conocerte.",
            quote: "Eres más fuerte de lo que crees. Te ayudaré a descubrirlo.",
        },
        legal: {
            back: "Volver al inicio", impressum_title: "Aviso Legal", datenschutz_title: "Política de Privacidad",
            placeholder: "Este texto es un marcador de posición y se completará con el contenido legal final.",
            impressum: {
                title: "Aviso Legal",
                intro:
                    "Información obligatoria conforme a la Ley Federal Suiza contra la Competencia Desleal (LCD) y al Reglamento General de Protección de Datos de la UE (RGPD).",
                provider_heading: "Proveedora",
                legal_form: "Empresa unipersonal · Práctica de coaching",
                address_pending: "Suiza",
                address_note:
                    "La dirección comercial completa se publicará con la activación del dominio definitivo.",
                website: "www.ella-onlinecoaching.ch",
                responsible_heading: "Responsable del contenido",
                responsible_body:
                    "Mercedes Köstel, como titular, es responsable de todos los contenidos de este sitio web. Las consultas, solicitudes de rectificación e información se gestionan exclusivamente a través de los datos de contacto indicados arriba.",
                disclaimer_heading: "Exención de responsabilidad",
                disclaimer_content:
                    "Los contenidos de este sitio web han sido elaborados con la mayor diligencia. No obstante, no se garantiza su exactitud, integridad ni actualidad. Los contenidos de coaching no constituyen asesoramiento médico, psicológico ni terapéutico, y no sustituyen ningún tratamiento profesional.",
                disclaimer_links:
                    "Las referencias y enlaces a sitios web de terceros quedan fuera de nuestro ámbito de responsabilidad. Se rechaza toda responsabilidad sobre dichos sitios. El acceso y uso se realizan bajo el propio riesgo del usuario.",
                copyright_heading: "Derechos de autor",
                copyright_body:
                    "Todos los textos, imágenes, gráficos y el diseño publicados en este sitio web están protegidos por derechos de autor. La reproducción, modificación, distribución o uso fuera de los límites del derecho de autor requiere el consentimiento por escrito de la proveedora.",
                jurisdiction:
                    "Legislación aplicable: Suiza · Jurisdicción: domicilio de la proveedora",
            },
            datenschutz: {
                title: "Política de Privacidad",
                intro:
                    "La protección de tus datos personales es muy importante para mí. Esta política de privacidad te informa, conforme a la Ley Suiza de Protección de Datos (LPD) y al Reglamento General de Protección de Datos de la UE (RGPD), sobre el tipo, alcance y finalidad de la recogida de datos en este sitio.",
                controller_label: "Responsable del tratamiento",
                last_updated: "Última actualización: febrero 2026",
                rights_label: "Tus derechos",
                rights_title: "Tú mantienes el control de tus datos.",
                rights_body:
                    "Conforme a la LPD y al RGPD, en cualquier momento puedes ejercer los siguientes derechos. Un correo electrónico es suficiente — respondo personalmente en un plazo de 7 días.",
                rights_items: [
                    "Derecho de acceso a los datos almacenados",
                    "Derecho de rectificación de datos inexactos",
                    "Derecho de supresión (“derecho al olvido”)",
                    "Derecho a la limitación del tratamiento",
                    "Derecho a la portabilidad de los datos",
                    "Derecho a retirar el consentimiento otorgado",
                ],
                rights_cta: "Enviar consulta de privacidad",
                sections: [
                    {
                        heading: "Qué datos se recogen",
                        body: [
                            "Al rellenar el formulario de análisis o el de contacto, recopilo exclusivamente los datos que tú me facilitas voluntariamente: nombre, correo electrónico, teléfono (opcional), edad y tus respuestas sobre objetivos, situación de vida, alimentación, sueño y salud. Estos datos se tratan con total confidencialidad.",
                            "Al acceder al sitio web se almacenan automáticamente datos de servidor no personales (IP anonimizada, tipo de navegador, referente, marca de tiempo). Estos datos sirven exclusivamente a fines de seguridad técnica y no se utilizan para crear perfiles.",
                        ],
                    },
                    {
                        heading: "Finalidad y base jurídica",
                        body: [
                            "El tratamiento de tus datos se realiza para preparar y ejecutar los servicios de coaching solicitados, responder a tu consulta y cumplir las obligaciones contractuales. La base jurídica es el art. 6 ap. 1 lit. b RGPD (ejecución contractual) y, en su caso, el art. 31 ap. 2 lit. a LPD.",
                            "Los datos solo se transmiten a terceros si es estrictamente necesario para prestar el servicio (ver sección siguiente).",
                        ],
                    },
                    {
                        heading: "Cookies y seguimiento",
                        body: [
                            "Este sitio no utiliza cookies de marketing ni de seguimiento. Sólo se emplean cookies técnicamente necesarias (por ejemplo, para la selección de idioma DE/ES). No es necesario que las aceptes, ya que no se realiza ningún análisis de tu comportamiento.",
                        ],
                    },
                    {
                        heading: "Encargados de tratamiento y servicios integrados",
                        body: [
                            "Para el correcto funcionamiento del sitio, utilizo los siguientes proveedores cuidadosamente seleccionados, con los que existen los correspondientes contratos de encargo de tratamiento:",
                        ],
                        list: [
                            "Stripe Payments Europe Ltd. (IRL) — procesamiento de pagos de los paquetes de coaching",
                            "Resend, Inc. (EE. UU.) — envío de correos de confirmación",
                            "LoopBook (Max Web Design, CH) — reservas online de la sesión inicial",
                            "MongoDB Atlas (región UE) — almacenamiento seguro de los formularios",
                        ],
                    },
                    {
                        heading: "Plazo de conservación y seguridad",
                        body: [
                            "Tus datos sólo se conservan durante el tiempo necesario para la finalidad del tratamiento o el plazo legal de conservación que corresponda (máximo 10 años para documentos contables conforme al art. 958f del Código Suizo de Obligaciones).",
                            "La transmisión se realiza siempre cifrada vía HTTPS/TLS. El acceso a los datos personales está limitado a la proveedora.",
                        ],
                    },
                ],
            },
        },
    },
};
